'use client';

import React from 'react';
import ContactSlider,{ContactProps} from 'components/commercetools-ui/organisms/contact';
import { TasticProps } from 'frontastic/tastics/types';
// import { TasticProps } from 'frontastic/tastics/types';


const ContactSliderTastic  = ({ data }: TasticProps<ContactProps>) => {
    
    return <ContactSlider data={data?.data?.dataSource}  />;
};

export default ContactSliderTastic;